<div class="group">
  <div class="header">
    <div class="label"
    #labelElement
    (mousedown)="onToggleEditLabel()"
    [ngClass]="{'edit': editLabel, 'disabled': disabled}">
      <nb-icon
      icon="editLabel"
      pack="custom"
      >
      </nb-icon>
      <biz-label-inline-edit
      fallback="WMS Rate Group - Draft"
      tag="h3"
      [edit]="editLabel"
      [notEmpty]="true"
      [value]="(
        getLabelValue()
      )"
      (valueChange)="onLabelChange($event)"
      >
    </biz-label-inline-edit>
    </div>
    <button class="wmsRatesDeleteButton" (click)="onRemove()"
    [disabled]="disabled">
      <nb-icon
      icon="trash-2-outline">
      </nb-icon>
      <span>Delete Rate Group</span>
    </button>
  </div>
  <div
  class="row">
  <nb-form-field
      class="toggle-field"
      [ngClass]="{
        'disabled-field': (
          pricelistIsReadOnly
        )
      }"
      *ngIf="hasSameExtraSKU">
      <nb-toggle
        labelPosition="end"
        [ngModel]="isExtraSKUSame"
        [disabled]="isExtraSKUSameDisabled || disabled || isSameCalculationDisabled"
        (ngModelChange)="onToggleChange()"
        *ngIf="!isExtraSKUSameDisabled; else disabledTooltip">
        Apply the same Extra SKU rate as in Order Fulfillment
      </nb-toggle>

      <ng-template #disabledTooltip>
        <nb-toggle
          labelPosition="end"
          [ngModel]="isExtraSKUSame"
          [disabled]="true"
          (ngModelChange)="onToggleChange()"
          nbTooltip="The Order Fulfilment rate type must be configured in order to enable this option"
          nbTooltipPlacement="end">
          Apply the same Extra SKU rate as in Order Fulfillment
        </nb-toggle>
      </ng-template>
    </nb-form-field>
    </div>
    <biz-ordered-list
      [disabled]="disabled"
      [items]="items"
      [optionMap]="optionMap"
      [itemEmpty]="itemEmpty"
      [singleRateTypes]="singleRateTypes"
      [fields]="fields"
      [isExtraSKUSameFlag]="isExtraSKUSame"
      [isWMSFlag]="isWMS"
      (edit)="onEdit($event)"
      *ngIf="items">
    </biz-ordered-list>
  </div>
  